import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function GuideDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [guide, setGuide] = useState(null);

  useEffect(() => {
    api.get(`/guides/${slug}`).then((r) => setGuide(r.data)).catch(() => nav("/guides"));
  }, [slug, nav]);

  if (!guide) return <div className="p-20 text-center">Loading…</div>;

  return (
    <article>
      <div className="relative h-[70vh] min-h-[500px] overflow-hidden">
        <img src={guide.cover_image} alt={guide.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-scrim" />
        <button onClick={() => nav(-1)} className="absolute top-6 left-6 btn-pill btn-outline !border-white/40 !text-white bg-black/20 backdrop-blur">
          <ArrowLeft size={16} /> Back
        </button>
        <div className="absolute bottom-12 left-0 right-0 px-6 lg:px-10">
          <div className="max-w-4xl mx-auto text-white text-center">
            <div className="text-xs uppercase tracking-[0.3em] opacity-80 mb-4">{guide.category.replace("-", " ")}</div>
            <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="font-display text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              {guide.title}
            </motion.h1>
            {guide.subtitle && <p className="mt-6 font-serif italic text-xl opacity-90 max-w-2xl mx-auto">{guide.subtitle}</p>}
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="flex items-center gap-4 pb-8 border-b border-[color:var(--forest-line)]">
          {guide.author_avatar && <img src={guide.author_avatar} alt={guide.author} className="w-12 h-12 rounded-full object-cover" />}
          <div>
            <div className="font-medium">{guide.author}</div>
            <div className="text-xs text-[color:var(--forest-2)]">{guide.read_time_min} min read · {new Date(guide.created_at).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}</div>
          </div>
        </div>
        <div className="prose-heygc mt-10">
          {guide.content.split("\n\n").map((p, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: p.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>") }} />
          ))}
        </div>
      </div>
    </article>
  );
}
